import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { setDisplayName, compose } from 'recompose';
import { connect } from 'react-redux';

import { getDataSelector } from 'redux/selectors';

ReactGA.initialize(process.env.GA_TRACKER, {
  debug: process.env.NODE_ENV !== 'production',
  testMode: process.env.API_BASE_URL !== 'https://api-v2.freshr.com/api', // Only deactivated at the production site
});
export const withTracker = (WrappedComponent, options = {}) => {
  const setUser = (accountId, accountEmail) => {
    ReactGA.set({ userId: accountId, dimension1: accountEmail });
  };

  const trackPage = (page) => {
    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.pageview(page);
  };

  class WithTracker extends Component {
    static propTypes = {
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }),
      tokenInfo: PropTypes.shape({}),
    };

    static defaultProps = {
      location: {
        pathname: '',
      },
      tokenInfo: {},
    };

    componentDidMount() {
      const { location: { pathname }, tokenInfo } = this.props;
      const { user } = tokenInfo.toJS();
      if (user) setUser(user.accountId, user.account.email);
      trackPage(pathname);
    }


    componentWillReceiveProps(nextProps) {
      const { pathname: currentPath } = this.props.location;
      const { pathname: nextPath } = nextProps.location;

      if (currentPath !== nextPath) {
        trackPage(nextPath);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  const mapStateToProps = state => ({
    tokenInfo: getDataSelector('auth', 'tokenInfo')(state),
  });
  return compose(
    setDisplayName('WithTracker'),
    connect(mapStateToProps),
  )(WithTracker);
};
